import * as React from 'react';
import { cn } from '../../lib/utils';

interface MonitorSettingsModalProps {
  children: React.ReactNode;
  className?: string;
}
export function MonitorSettingsModal({ children, className }: MonitorSettingsModalProps) {
  return (
    <div className={cn('flex max-h-[80vh] w-full max-w-2xl flex-col overflow-hidden', className)}>
      {children}
    </div>
  );
}

interface BodyProps {
  children: React.ReactNode;
  className?: string;
}
function Body({ children, className }: BodyProps) {
  return (
    <div className={cn('flex-1 overflow-y-auto', className)}>
      <div className={cn('mt-1 mb-4 flex flex-col space-y-4', className)}>{children}</div>
    </div>
  );
}

interface SubHeadingProps {
  children: React.ReactNode;
  className?: string;
}
function SubHeading({ children, className }: SubHeadingProps) {
  return <span className={cn('text-muted-foreground text-lg', className)}>{children}</span>;
}

interface FieldProps {
  label: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}
function Field({ label, error, children, className }: FieldProps) {
  return (
    <div className={cn('flex flex-col space-y-1', className)}>
      <span className="text-muted-foreground text-sm">{label}</span>
      {children}
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}

interface GridProps {
  children: React.ReactNode;
  className?: string;
}
function Grid({ children, className }: GridProps) {
  return <div className={cn('grid grid-cols-2 gap-3', className)}>{children}</div>;
}

MonitorSettingsModal.Body = Body;
MonitorSettingsModal.SubHeading = SubHeading;
MonitorSettingsModal.Field = Field;
MonitorSettingsModal.Grid = Grid;
